import React, { useState } from 'react';
import { HeroSection } from '../components/SalesLetter/HeroSection';
import { OpeningHook } from '../components/SalesLetter/OpeningHook';
import { PainAgitation } from '../components/SalesLetter/PainAgitation';
import { OldSolutions } from '../components/SalesLetter/OldSolutions';
import { UniqueMechanism } from '../components/SalesLetter/UniqueMechanism';
import { ProductReveal } from '../components/SalesLetter/ProductReveal';
import { AudienceSection } from '../components/SalesLetter/AudienceSection';
import { BenefitsSection } from '../components/SalesLetter/BenefitsSection';
import { Testimonials } from '../components/SalesLetter/Testimonials';
import { OfferStack } from '../components/SalesLetter/OfferStack';
import { Visualization } from '../components/SalesLetter/Visualization';
import { Guarantee } from '../components/SalesLetter/Guarantee';
import { UrgencySection } from '../components/SalesLetter/UrgencySection';
import { CTASection } from '../components/SalesLetter/CTASection';
import { FAQSection } from '../components/SalesLetter/FAQSection';
import { BotanicalDivider } from '../components/SalesLetter/ui/BotanicalDivider';
import { X } from 'lucide-react';
function LegalPopup({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-261">
      <div className="bg-[#FAF6F0] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-262">
        <div className="sticky top-0 bg-[#FAF6F0] flex items-center justify-between p-5 border-b border-[#4A5D3A]/10" data-id="element-263">
          <h2 className="text-xl font-serif font-bold text-[#2D2A26]" data-id="element-264">
            {title}
          </h2>
          <button onClick={onClose} className="text-[#2D2A26]/60 hover:text-[#2D2A26] transition-colors" data-id="element-265">
            <X size={24} data-id="element-266" />
          </button>
        </div>
        <div className="p-6 text-[#2D2A26]/80 text-sm leading-relaxed space-y-4" data-id="element-267">
          {children}
        </div>
      </div>
    </div>;
}
export function SalesPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <main className="min-h-screen bg-[#FAF6F0] text-[#2D2A26] font-sans selection:bg-[#4A5D3A] selection:text-[#FAF6F0] overflow-x-hidden" data-id="element-268">
      <HeroSection data-id="element-269" />
      <BotanicalDivider data-id="element-270" />

      <OpeningHook data-id="element-271" />
      <BotanicalDivider data-id="element-272" />

      <PainAgitation data-id="element-273" />
      <BotanicalDivider data-id="element-274" />

      <OldSolutions data-id="element-275" />
      <BotanicalDivider data-id="element-276" />

      <UniqueMechanism data-id="element-277" />
      <BotanicalDivider data-id="element-278" />

      <ProductReveal data-id="element-279" />
      <BotanicalDivider data-id="element-280" />

      <AudienceSection data-id="element-281" />
      <BotanicalDivider data-id="element-282" />

      <BenefitsSection data-id="element-283" />
      <BotanicalDivider data-id="element-284" />

      <Testimonials data-id="element-285" />
      <BotanicalDivider data-id="element-286" />

      <OfferStack data-id="element-287" />
      <BotanicalDivider data-id="element-288" />

      <Visualization data-id="element-289" />
      <BotanicalDivider data-id="element-290" />

      <Guarantee data-id="element-291" />
      <BotanicalDivider data-id="element-292" />

      <UrgencySection data-id="element-293" />

      <CTASection data-id="element-294" />
      <BotanicalDivider data-id="element-295" />

      <FAQSection data-id="element-296" />

      <footer className="py-6 text-center text-sm text-[#2D2A26]/40 border-t border-[#4A5D3A]/10 mt-8 space-y-3" data-id="element-297">
        <p data-id="element-298">
          © {new Date().getFullYear()} Rescate Herbáceo. Todos los derechos
          reservados.
        </p>
        <p className="text-xs" data-id="element-299">
          Este producto no sustituye el consejo médico profesional.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-300">
          <button onClick={() => setShowTerms(true)} className="underline hover:text-[#4A5D3A] transition-colors cursor-pointer" data-id="element-301">
            Términos y Condiciones
          </button>
          <span data-id="element-302">·</span>
          <button onClick={() => setShowPrivacy(true)} className="underline hover:text-[#4A5D3A] transition-colors cursor-pointer" data-id="element-303">
            Política de Privacidad
          </button>
        </div>
      </footer>

      {showTerms && <LegalPopup title="Términos y Condiciones" onClose={() => setShowTerms(false)} data-id="element-304">
          <p data-id="element-305">
            <strong data-id="element-306">1. Aceptación de los Términos</strong>
          </p>
          <p data-id="element-307">
            Al adquirir el producto digital "Rescate Herbáceo S.O.S.", aceptas
            estos términos y condiciones en su totalidad. Si no estás de acuerdo
            con alguno de estos términos, te pedimos que no realices la compra.
          </p>

          <p data-id="element-308">
            <strong data-id="element-309">2. Naturaleza del Producto</strong>
          </p>
          <p data-id="element-310">
            Este es un producto digital informativo y educativo. No constituye
            consejo médico, diagnóstico ni tratamiento. Siempre consulta con un
            profesional de la salud antes de iniciar cualquier protocolo con
            plantas medicinales, especialmente si estás embarazada, en período
            de lactancia o tomas medicamentos.
          </p>

          <p data-id="element-311">
            <strong data-id="element-312">3. Entrega del Producto</strong>
          </p>
          <p data-id="element-313">
            El acceso al producto digital se entrega de forma inmediata tras la
            confirmación del pago a través de la plataforma Hotmart. Recibirás
            un correo electrónico con las instrucciones de acceso.
          </p>

          <p data-id="element-314">
            <strong data-id="element-315">4. Garantía de Devolución</strong>
          </p>
          <p data-id="element-316">
            Ofrecemos una garantía de satisfacción de 7 días calendario a partir
            de la fecha de compra. Si no estás satisfecha con el producto,
            puedes solicitar un reembolso completo enviando un correo
            electrónico a nuestro equipo de soporte. No se requiere
            justificación.
          </p>

          <p data-id="element-317">
            <strong data-id="element-318">5. Propiedad Intelectual</strong>
          </p>
          <p data-id="element-319">
            Todo el contenido del producto está protegido por derechos de autor.
            Queda prohibida la reproducción, distribución o reventa total o
            parcial del material sin autorización expresa por escrito.
          </p>

          <p data-id="element-320">
            <strong data-id="element-321">6. Limitación de Responsabilidad</strong>
          </p>
          <p data-id="element-322">
            Los resultados pueden variar de persona a persona. No garantizamos
            resultados específicos. El uso de las plantas medicinales descritas
            es responsabilidad exclusiva del usuario.
          </p>

          <p data-id="element-323">
            <strong data-id="element-324">7. Modificaciones</strong>
          </p>
          <p data-id="element-325">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones serán efectivas desde su publicación.
          </p>
        </LegalPopup>}

      {showPrivacy && <LegalPopup title="Política de Privacidad" onClose={() => setShowPrivacy(false)} data-id="element-326">
          <p data-id="element-327">
            <strong data-id="element-328">1. Información que Recopilamos</strong>
          </p>
          <p data-id="element-329">
            Al realizar tu compra, recopilamos la información necesaria para
            procesar tu pedido: nombre, dirección de correo electrónico y datos
            de pago (procesados de forma segura por Hotmart).
          </p>

          <p data-id="element-330">
            <strong data-id="element-331">2. Uso de la Información</strong>
          </p>
          <p data-id="element-332">
            Tu información personal se utiliza exclusivamente para: procesar tu
            compra y entregarte el producto digital, enviarte comunicaciones
            relacionadas con tu compra, y brindarte soporte al cliente si lo
            solicitas.
          </p>

          <p data-id="element-333">
            <strong data-id="element-334">3. Protección de Datos</strong>
          </p>
          <p data-id="element-335">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros con fines comerciales. Tus datos de pago son procesados de
            forma segura por Hotmart y nunca tenemos acceso a tu información
            financiera completa.
          </p>

          <p data-id="element-336">
            <strong data-id="element-337">4. Cookies y Tecnologías de Seguimiento</strong>
          </p>
          <p data-id="element-338">
            Nuestra página de ventas puede utilizar cookies y tecnologías
            similares para mejorar tu experiencia de navegación y analizar el
            tráfico del sitio.
          </p>

          <p data-id="element-339">
            <strong data-id="element-340">5. Comunicaciones por Email</strong>
          </p>
          <p data-id="element-341">
            Al realizar tu compra, podrás recibir correos electrónicos
            relacionados con el producto y contenido educativo. Puedes darte de
            baja en cualquier momento haciendo clic en el enlace de cancelación
            de suscripción incluido en cada correo.
          </p>

          <p data-id="element-342">
            <strong data-id="element-343">6. Tus Derechos</strong>
          </p>
          <p data-id="element-344">
            Tienes derecho a acceder, rectificar o eliminar tu información
            personal en cualquier momento. Para ejercer estos derechos, contacta
            a nuestro equipo de soporte por correo electrónico.
          </p>

          <p data-id="element-345">
            <strong data-id="element-346">7. Cambios en esta Política</strong>
          </p>
          <p data-id="element-347">
            Nos reservamos el derecho de actualizar esta política de privacidad.
            Te notificaremos de cualquier cambio significativo por correo
            electrónico.
          </p>
        </LegalPopup>}
    </main>;
}